export const UPDATE_HEADER_USER_PROFILE_BEGIN = 'UPDATE_HEADER_USER_PROFILE_BEGIN';
export const UPDATE_HEADER_USER_PROFILE_ERROR = 'UPDATE_HEADER_USER_PROFILE_ERROR';
export const UPDATE_HEADER_USER_PROFILE_SUCCESS = 'UPDATE_HEADER_USER_PROFILE_SUCCESS';